module.exports = __webpack_public_path__ + "img/vjr.dc838769.jpg";